/** Derive related reds from the chosen accent for Tailwind `red-*` utilities. */

function clamp255(n: number) {
  return Math.max(0, Math.min(255, Math.round(n)));
}

function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
  const s = hex.trim();
  const m = /^#?([0-9a-f]{6})$/i.exec(s);
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

function rgbToHex(r: number, g: number, b: number) {
  return `#${[r, g, b].map((x) => clamp255(x).toString(16).padStart(2, '0')).join('')}`;
}

function mixRgb(a: { r: number; g: number; b: number }, b: { r: number; g: number; b: number }, t: number) {
  return {
    r: a.r + (b.r - a.r) * t,
    g: a.g + (b.g - a.g) * t,
    b: a.b + (b.b - a.b) * t,
  };
}

export function applyAccentPaletteToRoot(root: HTMLElement, accentHex: string): void {
  const base = hexToRgb(accentHex);
  if (!base) {
    root.style.setProperty('--d88-red-400', '#f87171');
    root.style.setProperty('--d88-red-600', '#dc2626');
    root.style.setProperty('--d88-red-700', '#b91c1c');
    return;
  }
  const light = mixRgb(base, { r: 255, g: 255, b: 255 }, 0.32);
  const d600 = mixRgb(base, { r: 0, g: 0, b: 0 }, 0.14);
  const d700 = mixRgb(base, { r: 0, g: 0, b: 0 }, 0.26);
  root.style.setProperty('--d88-red-400', rgbToHex(light.r, light.g, light.b));
  root.style.setProperty('--d88-red-600', rgbToHex(d600.r, d600.g, d600.b));
  root.style.setProperty('--d88-red-700', rgbToHex(d700.r, d700.g, d700.b));
}
